<div class="date-wrapper">
  <p class="date">{{ text }}</p>
</div>
